import { handleActions } from 'redux-actions';
import actions from '../actions';

const { fetch, add } = actions.products;

export default handleActions(
  {
    [fetch.toggle]: state => ({ ...state, fetching: !state.fetching }),
    [add]: (state, { payload }) => ({ ...state, ...payload }),
  },
  {
    lineups: [],
    items: [],
    discountOptions: {},
    paymentMethods: [],
  }
);



// WEBPACK FOOTER //
// ./src/reducers/products.js